import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetLeaveApply, doSaveLeaveApply, doDeleteLeaveApply } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { doLeaveApplyAction } from '../../business/LeaveApplyAction'
import { values } from 'lodash'
class LeaveApplyDetail extends React.Component {
	state = {
		changedValues基本信息: {},
	}

	componentDidMount = () => {
		this.doGetLeaveApply(this.props.id)
	}
	componentWillUnmount = () => {
		this.unmount = true
	}
	doGetLeaveApply = (id) => {
		const { dispatch, checkRecordID, taskName } = this.props
		dispatch(doGetLeaveApply({
			id: id || 0,
			checkRecordID,
			taskName,
			onEnd: ({ errorMessage, initValues基本信息, initValues假期余额, initValues出差事由, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, initValues基本信息, initValues假期余额, initValues出差事由, changedValues出差事由: {}, changedValues基本信息: {}, optionsParas })
				}
			}
		}))
	}

	handlerSave = () => {
		const { dispatch, onSave, onClose, checkRecordID } = this.props
		const { id, changedValues基本信息, initValues基本信息, changedValues出差事由 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		var newChangeValue = changedValues基本信息
		if (id == 0) {
			newChangeValue = {
				请假开始日期: values.请假开始日期,
				请假结束日期: values.请假结束日期,
				请假开始时段: values.请假开始时段,
				请假结束时段: values.请假结束时段,
				请假开始时间: values.请假开始时间,
				请假结束时间: values.请假结束时间,
				...changedValues基本信息
			}
		}
		dispatch(doSaveLeaveApply({
			id,
			checkRecordID,
			changedValues基本信息: newChangeValue,
			changedValues出差事由,
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					this.setState({ id })
					this.doGetLeaveApply(id)
				}
			}
		}))
	}

	handlerDelete = () => {
		const { dispatch, onClose, onSave } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			dispatch(doDeleteLeaveApply({
				id,
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			})))
	}

	handelSubmit = (action, title) => {
		const { onSave, onClose, dispatch, showDetail } = this.props
		const { id, initValues基本信息 } = this.state
		const { 超额请假时长, 假勤项目, 出差天数} = initValues基本信息
		if (action == '请假申请.提交') {
			const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
			if (假勤项目 == '出差') {
				const { list } = Tyan.utility.getListItems(this, '出差事由', '出差事由')
				if (list.length == 0) {
					Tyan.pubForm.showError('出差事由必须有一条')
					return
				}
			}
		}

		Tyan.doPostEvent({
			event: 'GetLeaveApplyFlowError',
			data: { id },
			onEnd: ({ errorMessage, ExcessiveLeaveHours, warn }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				if (action == '请假申请.提交' && warn)
					Tyan.pubForm.showConfirm(warn, () =>
						Tyan.doPostEvent({
							event: 'LeaveApplyFlow',
							data: {
								id,
								action: action,
								changedValues基本信息: {}
							},
							onEnd: ({ errorMessage }) => {
								if (errorMessage) {
									Tyan.pubForm.showError(errorMessage)
									return
								}
								Ext.toast('执行成功')
								onClose && onClose()
							}
						})
					)
				else if (action == '请假申请.提交' && ExcessiveLeaveHours && ExcessiveLeaveHours > 0 && 假勤项目 == "事假") {
					Tyan.pubForm.showConfirm('您本月事假请假天数已超出公司规定，请确认是否有特殊情况需要超额请假？', () =>
						Tyan.doPostEvent({
							event: 'LeaveApplyFlow',
							data: {
								id,
								action: action,
								changedValues基本信息: {}
							},
							onEnd: ({ errorMessage }) => {
								if (errorMessage) {
									Tyan.pubForm.showError(errorMessage)
									return
								}
								Ext.toast('执行成功')
								onClose && onClose()
							}
						})
					)
				}
				else {
					doLeaveApplyAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail, 假勤项目, 出差天数 })
				}
			}
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bSubmit = () => {
		const { initValues基本信息, changedValues基本信息, id } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		return Object.keys(changedValues基本信息).length > 0
	}

	handlerAddInfo = () => {
		addListItem(this, {}, '出差事由', '出差事由')
	}

	handlerDeleteInfo = (id) => {
		deleteListItem(this, '出差事由', '出差事由', id)
	}

	handleOutModeChange = (v) => {
		Tyan.doPostEvent({
			event: 'GetUnitName',
			data: {
				单位名称: v
			},
			onEnd: ({ errorMessage, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				console.log('optionsParas', optionsParas)
			}
		})
	}

	handleChange = (v) => {
		const 员工编号 = getFormValue(this, '基本信息', '员工编号')
		const 员工姓名 = getFormValue(this, '基本信息', '员工姓名')
		const { optionsParas } = this.state
		Tyan.doPostEvent({
			event: 'GetVacationBalanceByPersonName',
			data: {
				员工编号,
				员工姓名,
				假勤项目: v
			},
			onEnd: ({ errorMessage, initValues假期余额, 出行方式 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				if (v == '出差') {
					this.setState({ optionsParas: { ...optionsParas, 出行方式 } })
				}
				this.setState({ initValues假期余额 })
			}
		})
	}

	handleUnitChange = (type, id, v) => {
		Tyan.doPostEvent('GetRelationInfo', {
			data: { type, id, objRelationInfo: { [type]: v } },
			onEnd: ({ errorMessage, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				if (optionsParas) {
					this.setState({ optionsParas: { ...this.state.optionsParas, ...optionsParas } })
				}
			}
		})
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	bSave = () => {
		const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		const 假勤项目 = values.假勤项目
		const 假期时段 = optionsParas['假期时段'][假勤项目]
		const 请假附件 = getFormValue(this, '基本信息', '请假附件')
		return hasChangedValues(this) && 假勤项目 && (((假勤项目 == '公假' && values.服务单位 && values.是否产生误餐费) || (假勤项目 == '出差' && values.服务单位 && values.是否产生误餐费 && values.出行方式 && values.出差类别)) || (假勤项目 !== '公假' && 假勤项目 !== '出差')) &&
			((假期时段 == '每天一时段' && values.请假开始日期 && values.请假结束日期 && values.请假开始时段 && values.请假结束时段) ||
				(假期时段 == '连续时段' && values.请假开始时间 && values.请假结束时间)) && values.职务代理人 && values.请假原因 && values.任务交接说明 && ((请假附件.length > 0 &&
					['病假', '婚假', '丧假', '产假', '工伤假', '哺乳假'].indexOf(假勤项目) > -1) || ['病假', '婚假', '丧假', '产假', '工伤假', '哺乳假'].indexOf(假勤项目) == -1)
	}

	fieldset基本信息 = () => {
		const { initValues基本信息, changedValues基本信息, optionsParas } = this.state
		const { 状态名称, 超额请假时长, 是否申请人 } = initValues基本信息

		const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
		const 职务代理人 = getFormValue(this, '基本信息', '职务代理人')
		const 司机确认时间 = getFormValue(this, '基本信息', '司机确认时间')
		const 假期时段 = optionsParas['假期时段'][假勤项目]
		const item = []
		if (超额请假时长 != null && 假勤项目 != null && 状态名称 != "请假申请" && 超额请假时长 > 0 && 假勤项目 == "事假") {
			item.push(
				{
					_html: '', name: '超额请假时长文本', minWidth: '95%', style: {
						textAlign: 'left',
						color: 'red',
						fontSize: '12px',
						lineHeight: 1,
						fontWeight: 600,
					}
				}
			)
		}

		item.push(
			{
				_border: '请假申请信息', minWidth: '95%', disabled: 状态名称 !== '请假申请' || (状态名称 == '请假申请' && !是否申请人), items: [
					{ _text: '申请编号', minWidth: '45%', disabled: true },
					{ _date: '创建日期', minWidth: '45%', disabled: true },
					{ _text: '员工编号', minWidth: '45%', disabled: true },
					{ _text: '员工姓名', minWidth: '45%', disabled: true },
					{ _text: '部门名称', minWidth: '95%', disabled: true },
					{ _text: '职务名称', minWidth: '95%', disabled: true },
					{ _select: '职务代理人', minWidth: '45%', editable: true, required: true, },
					{ _select: '假勤项目', minWidth: '45%', required: true, onChange: (v) => this.handleChange(v), },
					{ _date: '请假日期', name: '请假开始日期', minWidth: '45%', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },
					{ _date: '~', name: '请假结束日期', minWidth: '45%', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },
					{ _select: '请假时段', name: '请假开始时段', minWidth: '45%', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },
					{ _select: '~', name: '请假结束时段', minWidth: '45%', cdt: () => 假期时段 && 假期时段 == '每天一时段', required: true },

					{ _datetime: '请假时间', name: '请假开始时间', minWidth: '45%', cdt: () => 假期时段 && 假期时段 == '连续时段', required: true },
					{ _datetime: '~', name: '请假结束时间', minWidth: '45%', cdt: () => 假期时段 && 假期时段 == '连续时段', required: true },

					{ _select: '服务单位', minWidth: '45%', cdt: () => 假勤项目 && (假勤项目 == '公假' || 假勤项目 == '出差'), required: true, },
					{ _radio: '是否产生误餐费', minWidth: '45%', cdt: () => 假勤项目 && (假勤项目 == '公假' || 假勤项目 == '出差') },
					{ _select: '出差类别', minWidth: '45%', cdt: () => 假勤项目 && 假勤项目 == '出差', required: true, },

					{ _select: '出行方式', minWidth: '45%', editable: true, forceSelection: true, cdt: () => 假勤项目 && 假勤项目 == '出差', required: true, },

					{ _text: '请假原因', minWidth: '95%', maxRows: 3, required: true, cdt: () => 假勤项目 && 假勤项目 != '出差', },
					{ _text: '出差原因', name: '请假原因', minWidth: '95%', maxRows: 3, required: true, cdt: () => 假勤项目 && 假勤项目 == '出差', },

					{ _text: '任务交接说明', minWidth: '95%', required: true, maxRows: 3, cdt: () => 职务代理人 },
					{ _files: '出差报告', name: '出差报告', minWidth: '95%', disabled: 状态名称 !== '报告中', cdt: () => 假勤项目 && 假勤项目 == '出差' && (状态名称 == '请假完成' || 状态名称 == '报告中'|| 状态名称 == '出差报告确认') },
					{ _files: '附件', name: '请假附件', minWidth: '95%', required: ['病假', '婚假', '丧假', '产假', '工伤假', '哺乳假'].indexOf(假勤项目) > -1, },
					{ _text: '备注', name: '请假备注', minWidth: '95%', maxRows: 3, },

					{ _text: '车牌号码', minWidth: '45%', cdt: () => 司机确认时间 && 司机确认时间 != nullDate, disabled: true, },
					{ _text: '驾驶员', minWidth: '45%', cdt: () => 司机确认时间 && 司机确认时间 != nullDate, disabled: true, },]
			},
			{
				_border: '销假申请信息', minWidth: '95%', disabled: 状态名称 !== '销假申请', hidden: 状态名称.indexOf('销假') == -1, margin: '30 0 0 20', items: [
					{ _text: '销假申请原因', minWidth: '95%', maxRows: 3, },
					{ _files: '附件', name: '销假附件', name: '销假附件', minWidth: '95%' },
					{ _text: '备注', name: '销假备注', minWidth: '95%', maxRows: 3, },
				]
			}
		)
		return item
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset假期余额 = () => {
		return [{
			_grid: '', name: '假期余额', rowNumbers: true, /* minRows: 1, maxRows: 2, */ height: '100%',
			columns: [
				{ _float: '总时长(h)', name: '总时长', flex: 20 },
				{ _float: '已休时长(h)', name: '已休时长', flex: 15 },
				{ _float: '剩余时长(h)', name: '剩余时长', flex: 15 },
				{ _datetime: '给假起始日', flex: 25, align: 'right' },
				{ _datetime: '可休截止日', flex: 25, align: 'right' },
			],
			buttons: [
			],
		},
		]
	}

	fieldset出差事由 = () => {
		const p = { margin: '5px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
		const { initValues基本信息, optionsParas } = this.state
		const { 状态名称, 是否申请人 } = initValues基本信息
		const { list: list出差事由 } = Tyan.utility.getListItems(this, '出差事由', '出差事由')
		return [
			{
				_group: '', minWidth: '95%', disabled: (状态名称 !== '请假申请' && 状态名称 !== '报告中') || (状态名称 == '请假申请' && !是否申请人), items: [
					{
						_group: '', name: '标题', items: [
							{ _label: '单位名称<font style=\'color:red\'>*</font>', name: '单位名称', disabled: true, ...p, flex: 2, },
							{ _label: '出行方式<font style=\'color:red\'>*</font>', name: '出行方式', disabled: true, ...p, },
							{ _label: '起日<font style=\'color:red\'>*</font>', name: '起日', disabled: true, ...p, },
							{ _label: '迄日<font style=\'color:red\'>*</font>', name: '迄日', disabled: true, ...p, },
							{ _label: '城市<font style=\'color:red\'>*</font>', name: '城市', disabled: true, ...p, },
							{ _label: '预计事项<font style=\'color:red\'>*</font>', name: '出差记录', disabled: true, ...p, },
							{
								_buttons: [
									{ _button: '添加', icon: '', ui: '', margin: 0, handler: () => this.handlerAddInfo(), cdt: () => 状态名称 == '请假申请' && 是否申请人 }
								], width: '101px', margin: 0
							}]
					},
				].concat(list出差事由 && list出差事由.map(({ id }) => {
					const list = { listName: '出差事由', id }
					return {
						_group: '', minWidth: '95%', /* dynamicRender: true, */ items: [
							{ _select: '', name: '单位名称', options: optionsParas[`单位名称_${id}`], list, ...p, editable: true, forceSelection: false, flex: 2, onChange: (v) => this.handleUnitChange('单位名称', id, v) },
							{ _select: '', name: '出行方式', optionName: '出行方式', list, ...p, },
							{ _date: '', name: '起日', list, ...p, },
							{ _date: '', name: '迄日', list, ...p, },
							{ _text: '', name: '城市', list, ...p, },
							{ _text: '', name: '出差记录', list, ...p, },
							{
								_buttons: [
									{
										_button: '删除', icon: 'trash-o', ui: 'decline', margin: 0,
										handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(id) }), cdt: () => 状态名称 == '请假申请' && 是否申请人
									}
								], width: '101px', margin: 0
							}]
					}
				}))
			},
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly, notSubmit } = this.props
		const { errorMessage, id, initValues基本信息, changedValues出差事由 } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 状态, 状态名称, 提交时间, 是否申请人, 流转日志 } = initValues基本信息
		const 假勤项目 = getFormValue(this, '基本信息', '假勤项目')
		var { list } = Tyan.utility.getListItems(this, '假期余额', '假期余额')
		const bSubmit = this.bSubmit()
		return <Body data={this} /* maxWidth="1100" */
			controls={
				(readOnly || (状态名称 == '请假申请' && !是否申请人)) ? [
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose }
				] : [
					{ _flow: 'OutApplyFlow', disabled: this.bSave(), cdt: () => id > 0 && !notSubmit },
					// { _button: '驳回', icon: 'reply', ui: 'action decline alt', handler: () => this.handelSubmit(`${状态名称}.驳回`, '驳回'), cdt: () => id > 0 && (状态 == 2 || 状态 == 4) && !notSubmit, disabled: bSubmit || this.bSave() },
					// { _button: '取消销假', icon: 'reply', ui: 'action decline alt', handler: () => this.handelSubmit(`${状态名称}.取消销假`, '取消销假'), cdt: () => id > 0 && 状态名称 == '销假申请' && !notSubmit, disabled: bSubmit || this.bSave() },
					{ _button: 状态名称 == '请假申请' ? '提交' : '确认', icon: 'share', handler: () => this.handelSubmit(`${状态名称}.提交`, '提交'), cdt: () => id > 0 && (状态名称 == '请假申请' || !notSubmit && 状态名称 == '请假批准'), disabled: bSubmit || this.bSave() },
					{ _button: '销假申请', icon: 'share', handler: () => this.handelSubmit(`${状态名称}.销假申请`, '销假申请'), cdt: () => id > 0 && 假勤项目 !== '外训' && 状态名称 == '请假完成' && !notSubmit, disabled: bSubmit || this.bSave() },
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), cdt: () => 状态 == 1 || 状态名称 == '报告中' },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && 状态 == 1 && 流转日志 == '', disabled: this.bSave(), },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '请假申请', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'left', width: '50%', forceDisabled: 状态 == 3 || readOnly },
					{ title: '出差事由', name: '出差事由', _fieldset: this.fieldset出差事由(), docked: 'top', height: '40%', cdt: () => 假勤项目 == '出差' },
					{ title: '假期余额', name: '假期余额', _fieldset: this.fieldset假期余额(), docked: 'top', height: '30%', fullblock: true, cdt: () => list.length > 0 },
					{
						_fieldsets: [
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
						]
					}

				]
			}
		/>
	}
}

export default connect()(LeaveApplyDetail)